import styled from "styled-components";

export const FurnitureSetWrapper = styled.div`
  width: 53px;
  height: 53px;
  background: var(--grey100);
  display: flex;
  align-items: center;
  justify-content: center;
`;
